import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { defaultTab: String }
  
  connect() {
    // Show the default tab or the first one
    const defaultTab = this.defaultTabValue || this.tabTargets[0]?.dataset.tab
    if (defaultTab) {
      this.showTab(defaultTab)
    }
  }
  
  selectTab(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tab
    this.showTab(tabName)
    
    // Update URL without page reload using Turbo
    const url = event.currentTarget.href
    if (url && window.Turbo) {
      window.history.pushState({}, '', url)
    }
  }
  
  showTab(tabName) {
    // Update tab states
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        tab.classList.add("font-semibold", "border-[#272A68]", "border-b-4", "text-[#272A68]")
        tab.classList.remove("text-tertiary-400", "font-medium", "border-transparent")
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.classList.remove("font-semibold", "border-[#272A68]", "border-b-4", "text-[#272A68]")
        tab.classList.add("text-tertiary-400", "font-medium", "border-transparent")
        tab.setAttribute("aria-selected", "false")
      }
    })
    
    // Update panel visibility
    this.panelTargets.forEach(panel => {
      if (panel.dataset.panel === tabName) {
        panel.classList.remove("hidden")
        panel.setAttribute("aria-hidden", "false")
      } else {
        panel.classList.add("hidden")
        panel.setAttribute("aria-hidden", "true")
      }
    })
  }
}
